<template>
  <div class="container">
    <ul class="tip primary">
      <li>
        <label class="text">发件人：</label>
        <label>{{ message.Sender }}</label>
      </li>
      <li>
        <label class="text">时间：</label>
        <label>{{ message.Publish }}</label>
      </li>
      <li>
        <label class="text">收件人：</label>
        <label class="value" v-for="item in message.Addressees" :key="item">{{
          item
        }}</label>
      </li>
      <li v-if="files.length > 0">
        <label class="text">原始附件：</label>
        <el-link
          v-for="file in files"
          :key="file.id"
          type="primary"
          target="_blank"
          :href="file.url"
          >{{ file.name }}</el-link
        >
      </li>
    </ul>
    <div class="message">
      <div class="text-space text-bold">{{ message.Message }}</div>
      <records type="Sys-Message" :id="message.Id" style="margin: 48px 0 0 0" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    records: () => import("@/views/system/record/list"),
  },
  data() {
    return {
      loading: false,
      message: null,
      files: null,
    };
  },
  created() {
    this.loadData(this.$route.params?.id);
  },
  methods: {
    loadData(id) {
      if (!id && this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.system.message
        .getInfo({
          id: id,
        })
        .then((res) => {
          this.message = res;
          return this.$apis.system.file.list({
            objectId: res.Id,
          });
        })
        .then((res) => {
          this.files = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  ul.tip {
    position: relative;
    .btns {
      position: absolute;
      right: 20px;
      top: 16px;
    }
    li {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      label.text {
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
        min-width: 80px;
      }
      label.value + label.value {
        margin-left: 10px;
      }
    }
  }
  .message {
    flex: 1;
    background: #fff;
    padding: 20px;
    line-height: 1.6;
    letter-spacing: 2px;
  }
}
</style>